import React, { PureComponent } from 'react';
import './style.scss';
import Table from '../../../../../components/table';
import { connect } from 'react-redux';
import { ACTIONS, getTeam1, convertBatterPitcherUse, convertListBatter } from './../../../../../actions/team-1';


class Batter extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            listBatterTeamReport : [],
            listTop3Batter: []
        }
        this.onRedirect = this.onRedirect.bind(this);
    }

    componentDidMount() {
        const id = this.props.id;
        this.props.getTeam1(id);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps) {
            if (nextProps.status === ACTIONS.GET_INFO_TEAM_1_SUCCESS) {
                this.setState({
                    listBatterTeamReport : nextProps.response.top3_batters && convertBatterPitcherUse(nextProps.response.top3_batters[0].players, nextProps.id),
                    listTop3Batter: convertListBatter(nextProps.response.top3_batters, nextProps.id)
                })
            }
        }
    }

    onRedirect(value) {
        this.props.history.push(`/player/${value.id}`);
    }

    render() {
        return (
            <div className="batter">
                <h3 className="batter-title">打者TOP3</h3>
                <div className="grid">
                    {
                        this.state.listTop3Batter && this.state.listTop3Batter.map((value, index) => {
                            return (
                                <div className="batter-block" key={index}>
                                    <Table
                                        header={value.headerTable}
                                        showCheckbox={false}
                                        showSearch={false}
                                        itemOfPage={value.items}
                                        isShowOptionTable={false}
                                        titleTable={value.title}
                                        showPagination={false}
                                        onRowClick={this.onRedirect}
                                    />
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ teamReport }) => {
    return {
        headerBattingAvgTable: teamReport.headerBattingAvgTable,
        titleBattingAvgTable: teamReport.titleBattingAvgTable,
        mockDataBattingAvgTable: teamReport.mockDataBattingAvgTable,
        headerHomeRunTable: teamReport.headerHomeRunTable,
        titleHomeRunTable: teamReport.titleHomeRunTable,
        mockDataHomeRunTable: teamReport.mockDataHomeRunTable,
        headerRBITable: teamReport.headerRBITable,
        titleRBITable: teamReport.titleRBITable,
        mockDataRBITable: teamReport.mockDataRBITable,
        headerStealTable: teamReport.headerStealTable,
        titleStealTable: teamReport.titleStealTable,
        mockDataStealTable: teamReport.mockDataStealTable,
        response: teamReport.response,
        status: teamReport.status
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getTeam1: (id) => {
            dispatch(getTeam1(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(Batter);
